import { Injectable } from '@angular/core';
import { FlexibleBenefit } from '../models/flexible-benefit';
import {OfferBenefits} from "../models/offer-benefits";

@Injectable({ providedIn: 'root' })
export class BenefitHelperService {
  public mapBenefitToDisplayPrice(benefit: FlexibleBenefit | OfferBenefits): FlexibleBenefit | OfferBenefits {

    let finalPrice = benefit.price + (benefit.price * benefit.serviceFee) / 100;
    if (benefit.includesVat === true){
      finalPrice = Math.round((finalPrice) * 100) / 100;
    } else {
      finalPrice = Math.round((finalPrice + (finalPrice * benefit.vatPercentage) / 100) * 100) / 100;
    }
    return Object.assign(
      benefit instanceof FlexibleBenefit ? new FlexibleBenefit() : new OfferBenefits(),
      benefit,
      {price: finalPrice}
    );
  }
}
